import React from 'react';
import PropTypes from 'prop-types';
import { css, cx } from '@bd/bdui-styles/emotion';
import { SanitizeHtml } from '@bd/bdcore-utilities';
import AccordionToggle from '../../components/AccordionToggle';

const styles = css`
  color:white;
  position: relative;
  @media (min-width: 768px) {
    text-align: center;
    font-size: 18px;
    line-height: 32px;
    margin-bottom: 80px;
  }
  .SectionDescription_head {
    display: none;
    @media (min-width: 768px) {
      text-align: center;
      display: block;
      margin-bottom: 0.714286em;
    }
  }
  .toggler{
    position: absolute;
    top:-140px;
  }
`;


function SectionDescription({ className, community }) {
  return (
    <div className={cx(styles, className)}>
      <AccordionToggle
        openOnId="overview"
        button="Neighborhood Overview"
      >
        <span id="overview" className="toggler" />
        <h3 className="CommunityDetail_sectionHead SectionDescription_head GoldText">Neighborhood Overview</h3>
        <div className="row">
          <div className="col-12 col-8" dangerouslySetInnerHTML={SanitizeHtml(community.description)} />
        </div>
      </AccordionToggle>
    </div>
  );
}

SectionDescription.propTypes = {
  className: PropTypes.string,
  community: PropTypes.object.isRequired,
};

SectionDescription.defaultProps = {
  className: undefined,
};

export default SectionDescription;



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/SectionDescription.js